import { useQuery } from '@tanstack/react-query';
import { listFolders } from '@/services/api/endpoints';
import type { Folder } from '@/types/domain';

export function useFolders(containerId: string | null) {
  return useQuery<Folder[]>({
    queryKey: ['folders', containerId],
    queryFn: () => listFolders(containerId as string),
    enabled: Boolean(containerId),
    staleTime: 30_000,
  });
}
